var map = {
	"./adfs-logo.svg": "716d",
	"./azure-logo.svg": "46b8",
	"./horizontal-logo.svg": "8f03",
	"./oidc-logo.svg": "2d18",
	"./themes/dark/horizontal-logo.svg": "0f59",
	"./themes/dark/vertical-logo.svg": "e2c0",
	"./themes/default/horizontal-logo.svg": "2ef5",
	"./themes/default/vertical-logo.svg": "c1a9",
	"./themes/example/horizontal-logo.svg": "3198",
	"./themes/example/vertical-logo.svg": "c100",
	"./vertical-logo.svg": "a390"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8df9";